import { useV2GetBundleBySlugQuery } from "@stepapp/core";
import { palette, spacing } from "@stepapp/ui";
import { useLocalSearchParams } from "expo-router";
import { useCallback, useState } from "react";
import { useFormContext } from "react-hook-form";
import { KeyboardAvoidingView, Platform, StyleSheet } from "react-native";
import { ScrollView } from "react-native";
import { ReservationNote } from "../../../src/components";
import { useAppSelector } from "../../../src/hooks";
import { ReservationFormParams } from "../../../src/store/draftReservation/types";

const ServiceNotesScreen = () => {
  const { slug } = useLocalSearchParams<{ slug: string }>();
  const localizationId = useAppSelector(({ appConfig }) => appConfig.localizationId);
  const { setValue, watch } = useFormContext<ReservationFormParams>();
  const customerNote = watch("customerNote");
  const [temporaryNote, setTemporaryNote] = useState(customerNote);

  const { data } = useV2GetBundleBySlugQuery({
    variables: { localizationId, slug },
    fetchPolicy: "cache-and-network",
    skip: !slug,
  });

  const onChangeTextBlur = useCallback(() => {
    setValue?.("customerNote", temporaryNote);
  }, [temporaryNote, setValue]);

  return (
    <KeyboardAvoidingView
      enabled
      behavior={Platform.select({ default: "padding", android: undefined })}
      keyboardVerticalOffset={spacing.unit * 20}
    >
      <ScrollView contentContainerStyle={styles.container}>
        <ReservationNote
          note={temporaryNote}
          type="edit"
          onChangeText={setTemporaryNote}
          onChangeTextBlur={onChangeTextBlur}
          categoryType={data?.v2GetBundleBySlug?.categoryType}
        />
      </ScrollView>
    </KeyboardAvoidingView>
  );
};

export default ServiceNotesScreen;

const styles = StyleSheet.create({
  container: {
    backgroundColor: palette.common.white,
    borderTopLeftRadius: spacing.radius * 2,
    borderTopRightRadius: spacing.radius * 2,
    minHeight: spacing.deviceHeight,
  },
});
